var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cancel",
    clipPath: "url(#clip0_527_3024)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.5 6C19.91 6 6.5 19.41 6.5 36C6.5 52.59 19.91 66 36.5 66C53.09 66 66.5 52.59 66.5 36C66.5 19.41 53.09 6 36.5 6ZM49.4 48.9C48.23 50.07 46.34 50.07 45.17 48.9L36.5 40.23L27.83 48.9C26.66 50.07 24.77 50.07 23.6 48.9C22.43 47.73 22.43 45.84 23.6 44.67L32.27 36L23.6 27.33C22.43 26.16 22.43 24.27 23.6 23.1C24.77 21.93 26.66 21.93 27.83 23.1L36.5 31.77L45.17 23.1C46.34 21.93 48.23 21.93 49.4 23.1C50.57 24.27 50.57 26.16 49.4 27.33L40.73 36L49.4 44.67C50.54 45.81 50.54 47.73 49.4 48.9Z",
    fill: "#003359"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_527_3024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.98442bd7ac07cdce4ea212f588df9554.svg";
export { ForwardRef as ReactComponent };